import { createApiClient } from '@restaurant/api-client';
import { authFetch } from '@/auth/token-interceptor';
import { env } from '@/env';
import { unwrap } from './errors';
import { reportFailedResponse, reportTransportFailure } from './report-failure';

async function readBody(response: Response): Promise<unknown> {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    return text.length > 0 ? { message: text } : null;
  }
}

async function reportingFetch(request: Request): Promise<Response> {
  let response: Response;
  try {
    response = await authFetch(request);
  } catch (err) {
    reportTransportFailure(request.url, err);
    throw err;
  }
  if (response.status >= 400) {
    reportFailedResponse(request.url, response, await readBody(response.clone()));
  }
  return response;
}

export const openapiClient = createApiClient({
  baseUrl: env.apiUrl,
  headers: { 'Content-Type': 'application/json' },
  fetch: reportingFetch,
});

export const aiOpenapiClient = createApiClient({
  baseUrl: env.aiUrl,
  headers: { 'Content-Type': 'application/json' },
  fetch: reportingFetch,
});

export function unwrapResult<T>(result: { data?: T; error?: unknown; response: Response }): T {
  const { response, error } = result;
  if (response.ok) return unwrap<T>({ status: response.status, body: result.data });
  const traceId = response.headers.get('x-trace-id');
  const body =
    traceId && error && typeof error === 'object' && !('traceId' in error)
      ? { ...error, traceId }
      : error;
  return unwrap<T>({ status: response.status, body });
}
